/**
 * Workaround for a Rolldown CJS-interop bug.
 *
 * Packages that publish a `tsc`-compiled CJS bundle set both
 * `Object.defineProperty(exports, '__esModule', { value: true })` and
 * `exports.default = X` for their default export. Rolldown's runtime
 * `__toESM` helper currently double-wraps such modules, so a default-import
 * resolves to `{ default: X, __esModule: true }` instead of `X`. The result:
 * `new X()` throws "X is not a constructor", `X.foo()` is undefined, etc.
 *
 * `unwrapDefault(X)` peels off the extra wrapper if present, otherwise
 * returns the value as-is — safe to apply unconditionally to CJS default
 * imports of suspect packages.
 *
 * TODO: remove once Rolldown supports Rollup's `output.interop` option (or
 * fixes the underlying interop helper).
 */
export const unwrapDefault = <T>(value: T): T => {
  const candidate = value as unknown as { default?: T; __esModule?: boolean };
  if (candidate && candidate.__esModule && candidate.default !== undefined) {
    return candidate.default;
  }
  return value;
};
